import axios from 'axios';

export const getExperienciaSys = async (token) => {

    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/experiencia_sys", {
            headers: {
                'Authorization': 'Bearer ' + token,
                "Content-Type": "application/json"
            }
        });

        switch (response.status) {
            case 200:
                return { equivalencias: response.data, error: "" };
            default:
                return { equivalencias: null, error: "Error desconocido." };
        }
    } catch (error) {
        return { equivalencias: null, error: "Error desconocido: " + error.message };
    }
}